import { render, staticRenderFns } from "./KundenspezifischeFelder.vue?vue&type=template&id=052f5a38"
import script from "./KundenspezifischeFelder.vue?vue&type=script&lang=js"
export * from "./KundenspezifischeFelder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports